/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OfferNoteEntryResponse } from '../../models/offer-note-entry-response';

export interface GetOfferNoteEntries$Params {
  id: number;
  text?: string;
  createUserId?: number;
  hasAttachments?: boolean;
}

export function getOfferNoteEntries(http: HttpClient, rootUrl: string, params: GetOfferNoteEntries$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OfferNoteEntryResponse>>> {
  const rb = new RequestBuilder(rootUrl, getOfferNoteEntries.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('text', params.text, {});
    rb.query('createUserId', params.createUserId, {});
    rb.query('hasAttachments', params.hasAttachments, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<OfferNoteEntryResponse>>;
    })
  );
}

getOfferNoteEntries.PATH = '/offers/{id}/note-entries';
